export default "__VITE_ASSET__uiOK430J__"